const classes = [
    'colorbox',
    'colorbox-iframe',
    'colorbox-iframe-narrow',
    'Button--iframe-wide-popup',
    'Button--iframe-narrow-popup',
    'newsletter-list',
    'colorbox-video',
];
const body = document.querySelector('body');
const makeId = (title) => {
    return `dialog-${title.replace(/\s+/, '')}-${Date.now()}`;
};

/**
 * display video dialog
 * @constructor
 * @param {HTMLAnchorElement} target - the anchor that was clicked
 */
const videoPopup = (target) => {
    let src = target.href;
    // youtube (/watch)(
    // convert -> http://www.youtube.com/watch?v=xLYWJtZyUFQ
    // to ->  http://www.youtube.com/v/xLYWJtZyUFQ
    if (src.match(/youtube\.com\/watch/)) {
        // get ID
        const myID = src.match(/v=([a-z0-9-_]+)/i);
        src = `https://www.youtube.com/embed/${myID[1]}`;
    }

    target.dataset.dialogVideo = src;
    target.dataset.dialogTitle = target.title ?? target.textContent;
    target.dataset.dialog = makeId(`video-${target.dataset.dialogTitle}`);
    target.dataset.dialogType = 'dialog';
    const event = new CustomEvent('set-up-dialog-button', { detail: target });
    window.dispatchEvent(event);
    target.click();

};

/**
 * display iframe dialog
 * @constructor
 * @param {HTMLAnchorElement} target - the anchor that was clicked
 */
const iframePopup = (target) => {
    target.dataset.dialogSrc = target.href;
    target.dataset.dialogSize =
        target.classList.contains('newsletter-list') ||
        target.classList.contains('Button--iframe-narrow-popup') ||
        target.classList.contains('colorbox-iframe-narrow')
            ? 'narrow'
            : 'wide';
    target.dataset.dialogTitle = target.title ?? target.textContent;
    target.dataset.dialog = makeId(`iframe-${target.dataset.dialogTitle}`);
    target.dataset.dialogType = 'dialog';
    const event = new CustomEvent('set-up-dialog-button', { detail: target });
    window.dispatchEvent(event);
    target.click();
};

/**
 * display image dialog
 * @constructor
 * @param {HTMLAnchorElement} target - the anchor that was clicked
 */
const imagePopup = (target) => {
    target.dataset.dialogTitle = target.alt ?? target.textContent;
    target.dataset.dialog = makeId(`image-${target.dataset.dialogTitle}`);
    target.dataset.dialogType = 'image';
    target.dataset.dialogSrc = target.href;
    const event = new CustomEvent('set-up-dialog-button', { detail: target });
    window.dispatchEvent(event);
    target.click();
};

body.addEventListener('click', (e) => {
    /** @var HTMLAnchorElement */
    const target = e.target.closest('a'); // the anchor tag
    if (target) {
        let el = target; // the element with the classnames on it
        let isPopup = false;

        classes.every((classname) => {
            if (target.classList.contains(classname)) {
                isPopup = true;
                return false;
            }
            if (target.closest(`.${classname}`)) {
                el = target.closest(`.${classname}`);
                isPopup = true;
                return false;
            }
            return true;
        });

        if (isPopup) {
            // set up and click on the dialogs if they are not set already
            if (!target.dataset.dialog) {
                e.preventDefault();
                if (el.classList.contains('colorbox-video')) {
                    videoPopup(target);
                } else if (
                    target.classList.contains('newsletter-list') ||
                    target.classList.contains('colorbox-iframe') ||
                    target.classList.contains('colorbox-iframe-narrow') ||
                    target.classList.contains('Button--iframe-wide-popup') ||
                    target.classList.contains('Button--iframe-narrow-popup')
                ) {
                    iframePopup(target);
                } else {
                    imagePopup(target);
                }
            }
        }
    }
});